import { HttpHeaders } from '@angular/common/http';

export const environment = {
  production: true,
  local: false,
  api_url: 'https://api-dev.hellocapitan.com/api/',
  reporting_url: 'https://reporting-dev.hellocapitan.com/api/',
  check_in_site_url: 'https://check-in-dev.hellocapitan.com',
  api_headers: new HttpHeaders({'Content-Type': 'application/json'}),
  stripe_client_id: 'ca_HXnNF5GG8aOJ58Q36FPcZzLvuGxkFp6K',
  age_of_majority: 18,
  sentry_dsn: 'https://30c58a0f9db74ac7b23862e728e32d05@o553154.ingest.sentry.io/5731328',
  default_pin_timeout_seconds: 30
};
